// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const AssistantVersionType = {
    ASSISTANT_VERSION_TYPE_INVALID: 'ASSISTANT_VERSION_TYPE_INVALID',
    ASSISTANT_VERSION_TYPE_PUBLISHED: 'ASSISTANT_VERSION_TYPE_PUBLISHED',
    ASSISTANT_VERSION_TYPE_DRAFT: 'ASSISTANT_VERSION_TYPE_DRAFT',
};
export const AssistantVersionTypeValue = {
    ASSISTANT_VERSION_TYPE_INVALID: 0,
    ASSISTANT_VERSION_TYPE_PUBLISHED: 1,
    ASSISTANT_VERSION_TYPE_DRAFT: 2,
};
export const TerminationCause = {
    TERMINATION_CAUSE_INVALID: 'TERMINATION_CAUSE_INVALID',
    TERMINATION_CAUSE_CALLER_HANGUP: 'TERMINATION_CAUSE_CALLER_HANGUP',
    TERMINATION_CAUSE_TIMEOUT: 'TERMINATION_CAUSE_TIMEOUT',
    TERMINATION_CAUSE_CARRIER_ERROR: 'TERMINATION_CAUSE_CARRIER_ERROR',
    TERMINATION_CAUSE_PROVIDER_ERROR: 'TERMINATION_CAUSE_PROVIDER_ERROR',
    TERMINATION_CAUSE_CONNECTION_ERROR: 'TERMINATION_CAUSE_CONNECTION_ERROR',
    TERMINATION_CAUSE_AI_HANGUP: 'TERMINATION_CAUSE_AI_HANGUP',
    TERMINATION_CAUSE_AI_TRANSFER: 'TERMINATION_CAUSE_AI_TRANSFER',
};
export const TerminationCauseValue = {
    TERMINATION_CAUSE_INVALID: 0,
    TERMINATION_CAUSE_CALLER_HANGUP: 1,
    TERMINATION_CAUSE_TIMEOUT: 2,
    TERMINATION_CAUSE_CARRIER_ERROR: 3,
    TERMINATION_CAUSE_PROVIDER_ERROR: 4,
    TERMINATION_CAUSE_CONNECTION_ERROR: 5,
    TERMINATION_CAUSE_AI_HANGUP: 6,
    TERMINATION_CAUSE_AI_TRANSFER: 7,
};
export const CallType = {
    CALL_TYPE_INVALID: 'CALL_TYPE_INVALID',
    CALL_TYPE_INBOUND: 'CALL_TYPE_INBOUND',
    CALL_TYPE_OUTBOUND: 'CALL_TYPE_OUTBOUND',
};
export const CallTypeValue = {
    CALL_TYPE_INVALID: 0,
    CALL_TYPE_INBOUND: 1,
    CALL_TYPE_OUTBOUND: 2,
};
export const CallSource = {
    CALL_SOURCE_INVALID: 'CALL_SOURCE_INVALID',
    CALL_SOURCE_PHONE: 'CALL_SOURCE_PHONE',
    CALL_SOURCE_BROWSER: 'CALL_SOURCE_BROWSER',
};
export const CallSourceValue = {
    CALL_SOURCE_INVALID: 0,
    CALL_SOURCE_PHONE: 1,
    CALL_SOURCE_BROWSER: 2,
};
export const App = {
    APP_UNSET: 'APP_UNSET',
    APP_BUSINESS_CENTER: 'APP_BUSINESS_CENTER',
    APP_PARTNER_CENTER: 'APP_PARTNER_CENTER',
};
export const AppValue = {
    APP_UNSET: 0,
    APP_BUSINESS_CENTER: 1,
    APP_PARTNER_CENTER: 2,
};
export const Participant = {
    PARTICIPANT_INVALID: 'PARTICIPANT_INVALID',
    PARTICIPANT_FROM: 'PARTICIPANT_FROM',
    PARTICIPANT_TO: 'PARTICIPANT_TO',
};
export const ParticipantValue = {
    PARTICIPANT_INVALID: 0,
    PARTICIPANT_FROM: 1,
    PARTICIPANT_TO: 2,
};
export const VendorModel = {
    VENDOR_MODEL_UNSPECIFIED: 'VENDOR_MODEL_UNSPECIFIED',
    VENDOR_MODEL_OPEN_AI_REALTIME: 'VENDOR_MODEL_OPEN_AI_REALTIME',
    VENDOR_MODEL_DEEPGRAM: 'VENDOR_MODEL_DEEPGRAM',
    VENDOR_MODEL_OPEN_AI_LIVE: 'VENDOR_MODEL_OPEN_AI_LIVE',
};
export const VendorModelValue = {
    VENDOR_MODEL_UNSPECIFIED: 0,
    VENDOR_MODEL_OPEN_AI_REALTIME: 1,
    VENDOR_MODEL_DEEPGRAM: 2,
    VENDOR_MODEL_OPEN_AI_LIVE: 3,
};
export const ElevenLabsVoiceRejectionReason = {
    ELEVEN_LABS_VOICE_REJECTION_REASON_INVALID: 'ELEVEN_LABS_VOICE_REJECTION_REASON_INVALID',
    ELEVEN_LABS_VOICE_REJECTION_REASON_NONE: 'ELEVEN_LABS_VOICE_REJECTION_REASON_NONE',
    ELEVEN_LABS_VOICE_REJECTION_REASON_NOT_FOUND: 'ELEVEN_LABS_VOICE_REJECTION_REASON_NOT_FOUND',
    ELEVEN_LABS_VOICE_REJECTION_REASON_SURCHARGE: 'ELEVEN_LABS_VOICE_REJECTION_REASON_SURCHARGE',
};
export const ElevenLabsVoiceRejectionReasonValue = {
    ELEVEN_LABS_VOICE_REJECTION_REASON_INVALID: 0,
    ELEVEN_LABS_VOICE_REJECTION_REASON_NONE: 1,
    ELEVEN_LABS_VOICE_REJECTION_REASON_NOT_FOUND: 2,
    ELEVEN_LABS_VOICE_REJECTION_REASON_SURCHARGE: 3,
};
